import src from "IMAGE";
export default { src, width: 122, height: 43, blurWidth: 0, blurHeight: 0};
